import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { QueryKey, UseQueryOptions } from 'react-query';
import type { RestaurantInquiryStatistics } from './types';
import { restaurantInquiriesEndpoint } from './use-create-restaurant-inquiry-api';

// GET /cms/restaurant-inquiries/statistics — global status-keyed count map for
// the dashboard cards (every enum status always present, plus `total`). No
// scoping params exist yet (assignee/date filters would need the list endpoint).
type TData = RestaurantInquiryStatistics;
type TError = AxiosError;
type Options = Omit<UseQueryOptions<TData, TError, TData, QueryKey>, 'queryKey' | 'queryFn'>;

export function useGetRestaurantInquiriesStatisticsApi(options?: Options) {
  return useQueryWrapper<TData, TError>(
    [restaurantInquiriesEndpoint, 'statistics'],
    async () => {
      const response = await http.get(`${restaurantInquiriesEndpoint}/statistics`);
      return response.data?.data ?? response.data;
    },
    options
  );
}
